import {RelativeTime} from '@primer/react'
import {ProfileReference} from '@github-ui/profile-reference'
import {StateType} from './types/list-types'
import styles from './PullsListItem.module.css'

interface PullsListItemTimestampContainerProps {
  createdAt: Date
  updatedAt: Date
  prState: StateType
  author: string
  isAgent?: boolean
  attributedUsername?: string
  onAuthorClick?: (author: string) => void
}

export const PullsListItemTimestampContainer = ({
  prState,
  author,
  createdAt,
  updatedAt,
  isAgent = false,
  attributedUsername,
  onAuthorClick,
}: PullsListItemTimestampContainerProps) => {
  const hasBeenUpdated = createdAt.getTime() !== updatedAt.getTime()
  const isOpen = prState === StateType.Opened
  const isClosed = !isOpen

  const authorContent = <ProfileReference login={author} profileName={author} isAgent={isAgent} />

  return (
    <span data-testid="timestamp-container">
      <span>&middot; </span>
      {attributedUsername && (
        <>
          {onAuthorClick ? (
            <button
              type="button"
              className={styles.filterLink}
              onClick={() => onAuthorClick(attributedUsername)}
              data-testid="attributed-author-filter-link"
              aria-label={`Filter by author ${attributedUsername}`}
            >
              <ProfileReference login={attributedUsername} profileName={attributedUsername} isAgent={false} />
            </button>
          ) : (
            <ProfileReference login={attributedUsername} profileName={attributedUsername} isAgent={false} />
          )}
          <span> with </span>
        </>
      )}
      {onAuthorClick ? (
        <button
          type="button"
          className={styles.filterLink}
          onClick={() => onAuthorClick(author)}
          data-testid="author-filter-link"
          aria-label={`Filter by author ${author}`}
        >
          {authorContent}
        </button>
      ) : (
        authorContent
      )}
      <span> opened </span>
      <RelativeTime date={createdAt} />
      {isOpen && hasBeenUpdated && (
        <span>
          {' '}
          <span>&middot;</span> <span>Updated</span> <RelativeTime date={updatedAt} />
        </span>
      )}
      {isClosed && (
        <span>
          {' '}
          <span>&middot;</span> <span>Closed</span> <RelativeTime date={updatedAt} />
        </span>
      )}
    </span>
  )
}
